import type { CustomerAddress } from '~/types/shopware'

type AccountType = 'private' | 'business'
type BusinessAddressFields = Pick<CustomerAddress, 'company' | 'department'>
type ShopAccountAddressPayload<T extends BusinessAddressFields> = Omit<T, keyof BusinessAddressFields> & {
  company: string
  department: string
}

export const getInitialBusinessAddressState = (
  address: BusinessAddressFields | undefined,
  accountType: AccountType | undefined,
): boolean => {
  if (address) {
    return Boolean(address.company?.trim() || address.department?.trim())
  }

  return accountType === 'business'
}

export const buildShopAccountAddressPayload = <T extends BusinessAddressFields>(
  address: T,
  isBusiness: boolean,
): ShopAccountAddressPayload<T> => ({
  ...address,
  company: isBusiness ? (address.company?.trim() ?? '') : '',
  department: isBusiness ? (address.department?.trim() ?? '') : '',
})
